"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  FETCH: "@@rgcp-html/fetch",
  LIST: "@@rgcp-html/list",
  DEFAULT_HTML_LIST: "@@rgcp-html/default-html-list",
  DELETE: "@@rgcp-html/delete",
  ADD: "@@rgcp-html/add",
  UPDATE: "@@rgcp-html/update",
  RESET: "@@rgcp-html/reset",
  TYPES: "@@rgcp-html/types",
  PREVIEW_LIST: "@@rgcp-html/PREVIEWlist",
  RGCP_PREVIEW: "@@rgcp-html/RgcpList",
  RGCP_PERFORMANCE_PREVIEW: "@@rgcp-html/RgcpPerformanceList",
  SUCCESS: "@@rgcp-html/success",
  ERROR: "@@rgcp-html/error",
  SOFT_DELETE: "@@rgcp-html/soft-delete",
  SOFT_DELETE_RESTORE: "@@rgcp-html/soft-delete-restore",
  SOFT_DELETED_LIST: "@@rgcp-html/soft-deleted-list",
  BULK_SOFT_DELETE: "@@rgcp-html/bulk-soft-delete",
  BULK_RESTORE: "@@rgcp-html/bulk-restore",
  BULK_HARD_DELETE: "@@rgcp-html/bulk-hard-delete"
};
exports.actionTypes = actionTypes;